<div class="grid-input-container">
  <label *ngIf="showFloatLabel" class="grid-input-label">{{ placeholder }}</label>
  <div #spreadsheet class="spreadsheet-wrapper"></div>
</div>
